import { combineReducers } from "redux";
import user from "./user";
import department from "./department";
import unit from "./unit";
import customer from "./customer";
import dutyType from "./dutyType";
import role from "./role";
import shift from "./shift";
import station from "./station";
import subActivity from "./subActivity";
import microActivity from "./microActivity";
import product from "./product";
import remark from "./remark";
import project from "./project";
import technician from "./technician";
import contractor from "./contractor";
import timesheet from "./timesheet";
import designation from "./designation";
import employeeActivityReport from "./reports";

export const reducers = combineReducers({
    user,
    department,
    unit,
    customer,
    dutyType,
    role,
    shift,
    station,
    subActivity,
    microActivity,
    product,
    remark,
    project,
    technician,
    contractor,
    timesheet,
    designation,
    employeeActivityReport,
});
